import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { CAMERA_STREAM_READ, CAMERAS_PAGE_READ } from '~/components/routes/cameras/permissions'
import { withRoutePermissions } from '~/utils/rbac'
import { isPermissionSatisfied } from '~/utils/rbacModuleIndex'

/**
 * `/cameras` — l'ancienne vue Caméras, retirée (retours de Chloé, 14/10). L'URL reste, pour
 * l'entrée de menu « Caméras », les favoris et les liens existants : elle mène au premier écran
 * autorisé, la vue qui la remplace (`/cameras/new`, boutique et caméra comprises), sinon la
 * configuration des caméras pour un rôle qui n'a que `read cameras.cameras.config` (BLOQ-03). La
 * garde reste celle de l'ancien écran.
 */
export const Route = createFileRoute('/_authenticated/cameras/')({
  staticData: {
    permission: CAMERAS_PAGE_READ,
  },
  validateSearch: z.object({
    storeId: z.number().int().positive().optional(),
    focusedCameraId: z.number().int().positive().optional(),
  }),
  beforeLoad: ({ context, search }) => {
    if (!isPermissionSatisfied(context.ability, CAMERA_STREAM_READ)) {
      throw redirect({ to: '/cameras/config', search: { storeId: search.storeId }, replace: true })
    }
    throw redirect({ to: '/cameras/new', search, replace: true })
  },
})
withRoutePermissions(Route)
